import { useState, useEffect } from "react";
import Cookies from 'universal-cookie';
import MD5 from "crypto-js/md5";

// Helper function to get bizcode from login cookie
function getBizcode() {
  const cookies = new Cookies();
  const login = cookies.get('login');
  return login ? login.bizcode : null;
}

export const UseLocalStorage = (key, initialValue) => {
  const [value, setValue] = useState(() => {
    const storedValue = localStorage.getItem(key);

    try {
      return JSON.parse(storedValue);
    } catch (err) {
      return initialValue;
    }
  });

  useEffect(() => {
    localStorage.setItem(key, JSON.stringify(value));
  }, [key, value]);

  return [value, setValue];
};

export function SearchAttributes(key, attributes) {
  const results = attributes.filter(
    (a) => {
      if (a.assignment.toLowerCase() === 'tickets') {
        return a.tags.filter(
          (t) => {
            if (t.tag.toLowerCase() === key) {
              return t;
            }
          }
        )
      }
      return null;
    }
  );
  return results;
}

export function GetColumnHeaders(tags) {
  const results = tags.filter(
    (t) => {
      if (t.searchable.toLowerCase() === 'true') {
        return t.displayname;
      }
    }
  )
  return results;
}

export function GetAttributesByAssignment(key, attributes) {
  for (let i = 0; i < attributes.length; i++) {
    if (attributes[i].assignment.toLowerCase() === key) {
      return attributes[i];
    }
  }
  return null;
}

export async function performUserLogin(username, userpass) {
  let hashpass = MD5(userpass).toString();

  const requestOptions = {
    method: 'POST',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json;charset=utf-8',
      'x-api-key': process.env.REACT_APP_LOGIN_KEY
    },
    body: JSON.stringify({
      "action": "do_login",
      "data": { "username": username.toLowerCase(), "pword": hashpass }
    })
  };

  let myurl = process.env.REACT_APP_LOGIN_URL
  let data = {};
  try {
    const response = await fetch(myurl, requestOptions);
    data = await response.json();
  } catch (error) {
    console.error('Error with login fetch:', error);
    data = {
      status: "ERROR"
    };
  }

  if (data.status === "SUCCESS") {
    const cookies = new Cookies();
    // Store the complete user data including bizcode
    cookies.set('login', data.body);
    console.log('Login cookie set with bizcode:', data.body.bizcode);
    return true;
  } else {
    return false;
  }
}

export async function performUserSignup(username, userpass, bizcode) {
  let hashpass = MD5(userpass).toString();

  const requestOptions = {
    method: 'POST',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json;charset=utf-8',
      'x-api-key': process.env.REACT_APP_LOGIN_KEY
    },
    body: JSON.stringify({
      "action": "create_account",
      "data": { 
        "username": username, 
        "pword": hashpass,
        "bizcode": bizcode
      }
    })
  };

  let myurl = process.env.REACT_APP_LOGIN_URL
  let data = {};
  try {
    const response = await fetch(myurl, requestOptions);
    data = await response.json();
  } catch (error) {
    console.error('Error with signup fetch:', error);
    data = {
      status: "ERROR",
      body: "Network error occurred"
    };
  }

  if (data.status === "SUCCESS") {
    const cookies = new Cookies();
    // Store the complete user data including bizcode
    cookies.set('login', data.body);
    console.log('Signup successful, login cookie set with bizcode:', data.body.bizcode);
    return { success: true };
  } else {
    return { success: false, error: data.body };
  }
}

export const GetAttributes = async () => {
  const cookies = new Cookies();
  let login = cookies.get('login');

  const requestOptions = {
    method: 'POST',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'x-api-key': login.token
    },
    body: JSON.stringify({
      "action": "get_attributes",
      "code": getBizcode(),
      "data": ""
    })
  };

  const backend_url = process.env.REACT_APP_BACKEND_URL;
  try {
    const request = await fetch(backend_url, requestOptions);
    const response = await request.json();

    if (response.status === "SUCCESS") {
      console.log('Tickets retrieved successful');
      let resp = response.body;
      return resp;
    } else {
      return null;
    }
  } catch (err) {
    console.log('Error getting Attributes: ' + err);
    return null;
  }

}

export const populateTicketList = async () => {
  const cookies = new Cookies();
  let login = cookies.get('login');

  const requestOptions = {
    method: 'POST',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'x-api-key': login.token
    },
    body: JSON.stringify({
      "action": "get_tickets",
      "code": getBizcode(),
      "data": ""
    })
  };
  let myurl = process.env.REACT_APP_BACKEND_URL;
  const request = await fetch(myurl, requestOptions);
  const response = await request.json();

  if (response.status === "SUCCESS") {
    console.log('Tickets retrieved successful');
    let resp = response.body;
    return resp.data;
  } else {
    return null;
  }
}

export async function performCustomerInput(data) {
  const cookies = new Cookies();
  let login = cookies.get('login');

  const requestOptions = {
    method: 'POST',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'x-api-key': login.token
    },
    body: JSON.stringify({
      "action": "insert_customer",
      "code": getBizcode(),
      data
    })
  };

  const request = await fetch(process.env.REACT_APP_BACKEND_URL, requestOptions);
  const response = await request.json();

  if (response.status === "SUCCESS") {
    console.log('Customer save successful');
    return true;
  } else {
    return false;
  }

}

export async function getCustomerTickets(customername) {
  const cookies = new Cookies();
  let login = cookies.get('login');

  const requestOptions = {
    method: 'POST',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'x-api-key': login.token
    },
    body: JSON.stringify({
      "action": "get_customer_tickets",
      "code": getBizcode(),
      "data": customername
    })
  };

  const request = await fetch(process.env.REACT_APP_BACKEND_URL, requestOptions);
  const response = await request.json();

  if (response.status === "SUCCESS") {
    console.log('Customer tickets retrieved successful');
    let resp = response.body;
    return resp;
  } else {
    return null;
  }

}

export async function populateCustomerList() {
  const cookies = new Cookies();
  let login = cookies.get('login');

  const requestOptions = {
    method: 'POST',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'x-api-key': login.token
    },
    body: JSON.stringify({
      "action": "get_customers",
      "code": getBizcode(),
      "data": ""
    })
  };

  const request = await fetch(process.env.REACT_APP_BACKEND_URL, requestOptions);
  const response = await request.json();

  if (response.status === "SUCCESS") {
    console.log('Customers retrieved successful');
    let customers = response.body;
    return customers;
  } else {
    return null;
  }

}

export async function performTicketInput(data) {
  const cookies = new Cookies();
  let login = cookies.get('login');
  data.id = data.ticketnumber;

  // Debug: Log the data being sent to see if tax and material are included
  console.log('Ticket data being sent to backend:', data);

  const requestOptions = {
    method: 'POST',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'x-api-key': login.token
    },
    body: JSON.stringify({
      "action": "insert_ticket",
      "code": getBizcode(),
      data
    })
  };

  try {
    const request = await fetch(process.env.REACT_APP_BACKEND_URL, requestOptions);
    const response = await request.json();

    if (response.status === "SUCCESS") {
      console.log('Ticket save successful');
      return response.body;
    } else {
      return false;
    }
  } catch (error) {
    console.error('Error uploading file:', error);
  }
}

export async function getTicketAttachments(ticket_id) {
  const cookies = new Cookies();
  let login = cookies.get('login');

  const requestOptions = {
    method: 'POST',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'x-api-key': login.token
    },
    body: JSON.stringify({
      "action": "get_ticket_attachments",
      "code": getBizcode(),
      "data": ticket_id
    })
  };

  const request = await fetch(process.env.REACT_APP_BACKEND_URL, requestOptions);
  const response = await request.json();

  if (response.status === "SUCCESS") {
    console.log('Ticket attachments metadata retrieved successfully');
    return response.body;
  } else {
    console.error('Error retrieving ticket attachments:', response.body);
    return [];
  }
}

export async function addAttachmentToTicket(ticket_id, file_data, file_name) {
  const cookies = new Cookies();
  let login = cookies.get('login');

  const requestOptions = {
    method: 'POST',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'x-api-key': login.token
    },
    body: JSON.stringify({
      "action": "add_attachment",
      "code": getBizcode(),
      "data": {
        "ticket_id": ticket_id,
        "fileData": file_data,
        "fileName": file_name
      }
    })
  };

  const request = await fetch(process.env.REACT_APP_BACKEND_URL, requestOptions);
  const response = await request.json();

  if (response.status === "SUCCESS") {
    console.log('Attachment added successfully');
    return response.body;
  } else {
    console.error('Error adding attachment:', response.body);
    return null;
  }
}

export async function downloadAttachment(ticket_id, file_name) {
  const cookies = new Cookies();
  let login = cookies.get('login');

  const requestOptions = {
    method: 'POST',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'x-api-key': login.token
    },
    body: JSON.stringify({
      "action": "download_attachment",
      "code": getBizcode(),
      "data": {
        "ticket_id": ticket_id,
        "file_name": file_name
      }
    })
  };

  const request = await fetch(process.env.REACT_APP_BACKEND_URL, requestOptions);
  const response = await request.json();

  if (response.status === "SUCCESS") {
    console.log('Attachment downloaded successfully');
    return response.body;
  } else {
    console.error('Error downloading attachment:', response.body);
    return null;
  }
}

export async function getFullTicket(ticket_id) {
  const cookies = new Cookies();
  let login = cookies.get('login');

  const requestOptions = {
    method: 'POST',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'x-api-key': login.token
    },
    body: JSON.stringify({
      "action": "get_single_ticket",
      "code": getBizcode(),
      "data": ticket_id
    })
  };

  const request = await fetch(process.env.REACT_APP_BACKEND_URL, requestOptions);
  const response = await request.json();

  if (response.status === "SUCCESS") {
    console.log('Ticket retrieved successful');
    let resp = response.body;
    return resp;
  } else {
    return null;
  }
}

export async function performPasswordChange(currentPassword, newPassword) {
  const cookies = new Cookies();
  let login = cookies.get('login');

  if (!login) {
    console.error('No login cookie found');
    return false;
  }

  let hashCurrentPass = MD5(currentPassword).toString();
  let hashNewPass = MD5(newPassword).toString();

  const requestOptions = {
    method: 'POST',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json;charset=utf-8',
      'x-api-key': process.env.REACT_APP_LOGIN_KEY
    },
    body: JSON.stringify({
      "action": "change_password",
      "code": getBizcode(),
      "data": {
        "username": login.username,
        "currentPassword": hashCurrentPass,
        "newPassword": hashNewPass
      }
    })
  };

  let myurl = process.env.REACT_APP_LOGIN_URL;
  let data = {};
  try {
    const response = await fetch(myurl, requestOptions);
    data = await response.json();
  } catch (error) {
    console.error('Error with password change fetch:', error);
    data = {
      status: "ERROR"
    };
  }

  if (data.status === "SUCCESS") {
    console.log('Password change successful');
    return true;
  } else {
    console.error('Password change failed:', data.body);
    return false;
  }
}

export async function populateInventoryList() {
  const cookies = new Cookies();
  let login = cookies.get('login');

  const requestOptions = {
    method: 'POST',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'x-api-key': login.token
    },
    body: JSON.stringify({
      "action": "get_inventory",
      "code": getBizcode(),
      "data": ""
    })
  };

  const request = await fetch(process.env.REACT_APP_BACKEND_URL, requestOptions);
  const response = await request.json();

  if (response.status === "SUCCESS") {
    console.log('Inventory retrieved successful');
    let inventory = response.body;
    return inventory;
  } else {
    return null;
  }
}

export async function performInventoryInput(data) {
  const cookies = new Cookies();
  let login = cookies.get('login');

  const requestOptions = {
    method: 'POST',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'x-api-key': login.token
    },
    body: JSON.stringify({
      "action": "insert_inventory",
      "code": getBizcode(),
      data
    })
  };

  const request = await fetch(process.env.REACT_APP_BACKEND_URL, requestOptions);
  const response = await request.json();

  if (response.status === "SUCCESS") {
    console.log('Inventory save successful');
    return true;
  } else {
    return false;
  }
}